<template>
  <div class="avatar-image" :class="{ 'with-initials': initialLetters }">
    <div class="initials" v-if="initialLetters">{{ initialLetters }}</div>
    <div class="avatar-img" :style="style"></div>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: [Object, String],
    },
    initials: {
      type: [String, Object],
    },
    cacheKey: {
      type: [String, Number],
    },
  },
  data() {
    return {
      stringID: this.$sdk.utils.id(this.id),
    };
  },
  watch: {
    id(id) {
      this.stringID = this.$sdk.utils.id(id);
    },
  },
  computed: {
    initialString() {
      if (typeof this.initials === "string") {
        return this.initials;
      }
      const firstName = this.initials?.firstName || "";
      const lastName = this.initials?.lastName || "";
      const name = `${firstName} ${lastName}`.trim();
      const title = this.initials?.title;
      return name || title;
    },
    initialLetters() {
      const name = this.initialString || "";
      if (!name || !name.length) {
        return "";
      }

      // Split the string by whitespace
      const parts = name.split(/\s+/);

      // Get the first letter of first two parts if they exist
      let initials = "";
      if (parts[0]) {
        initials += String(parts[0][0] || "").toUpperCase();
      }
      if (parts[1]) {
        initials += String(parts[1][0] || "").toUpperCase();
      }

      return initials;
    },
    url() {
      const params = {};

      if (this.cacheKey) {
        params.cacheKey = this.cacheKey;
      }

      return this.$sdk.api.generateEndpointURL(
        `/image/${this.stringID}`,
        params,
        { file: true },
      );
    },
    style() {
      const style = {};

      style.backgroundImage = `url(${this.url})`;

      return style;
    },
  },
};
</script>
<style scoped lang="scss">
.avatar-image {
  width: 100%;
  display: block;
  border-radius: 100%;
  overflow: hidden;
  position: relative;
  background-color: color-mix(
    in lab,
    currentColor 25%,
    var(--bg1, transparent)
  );
  container-type: inline-size;

  .avatar-img {
    background-size: cover;
    background-position: center center;
    height: 0;
    padding-bottom: 100%;
    position: relative;
  }

  .initials {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    font-size: 0.9em;
    font-weight: 500;
    color: var(--bg1, currentColor);
    font-size: 50cqw;
  }
}
</style>
